const $nav = $('#model-nav');
const $navLinks = $('#model-nav-links');
const $navAdditionalSection = $('.model-nav__additional-info');
const $navRelContainer = $('.nav-rel-container');
const $sumSection = $('.model-summary-section');
const $navPlaceholder = $('.model-nav__hidden-placeholder');
const $similarSection = $('#similar-models');
const $recallsSection = $('.product-model-recall-container');

export const getHeightOfHiddenContainer = ($el) => {
    const previousCss = $el.attr("style");

    $el.css({
            position:   'absolute',
            visibility: 'hidden',
            display:    'block'
        });

    const outerHeight = $el.outerHeight(true);
    $el.attr("style", previousCss ? previousCss : "");

    return outerHeight;
};

const calculateNavLinksHeight = () => {
    return $navLinks.outerHeight(true);
};

const calculateNavAdditionalSectionHeight = () => {
    return getHeightOfHiddenContainer($navAdditionalSection);
};

const calculateSimilarsTopPossition = () => {
    return $similarSection.offset().top;
};

const calculateNavTopPossition = (subtractOffset = 0) => {
    if ($recallsSection.length > 0) {
        return $recallsSection.outerHeight(true) + $recallsSection.offset().top - subtractOffset;
    } else {
        return $sumSection.outerHeight(true) + $sumSection.offset().top - subtractOffset;
    }
};

function setNavPlaceholderHeight() {
    $navPlaceholder.css({
        height : navLinksHeight,
        display : 'block'
    });
}

function setNavTop(isPushed) {
    if(isPushed) {
        similarPos = calculateSimilarsTopPossition();
        summaryPos = calculateNavTopPossition(additionalSectionHeight);
        $navRelContainer.css({ top: similarPos - summaryPos - navHeight - additionalSectionHeight });
    } else {
        $navRelContainer.css({ top: '' });
    }
}

let additionalSectionHeight = calculateNavAdditionalSectionHeight();
let navLinksHeight = calculateNavLinksHeight();
let navHeight = navLinksHeight + additionalSectionHeight;
let summaryPos = calculateNavTopPossition(additionalSectionHeight);
let similarPos = calculateSimilarsTopPossition();


/**
 *  recalculates nav's height and coordinates when user changes window's size or orientation
 *
 */
$(window).on('load resize orientationchange onpopstate onpushstate', function () {
    additionalSectionHeight = calculateNavAdditionalSectionHeight();
    navLinksHeight = calculateNavLinksHeight();
    summaryPos = calculateNavTopPossition(additionalSectionHeight);
    similarPos = calculateSimilarsTopPossition();
    navHeight = navLinksHeight + additionalSectionHeight;
});

export const pinNav = () => {

    if ($(window).scrollTop() >= similarPos - navHeight) {
        if (!$nav.hasClass('affix-bottom')) setNavTop(true);

        $nav.removeClass('affix')
            .removeClass('affix-top')
            .addClass('affix-bottom');

    } else if ($(window).scrollTop() >= summaryPos) {
        $nav.removeClass('affix-bottom')
            .removeClass('affix-top')
            .addClass('affix');

        setNavTop(false);
    } else {
        $nav.removeClass('affix')
            .removeClass('affix-bottom')
            .addClass('affix-top');

        setNavTop(false);
    }

    setNavPlaceholderHeight();
    requestAnimationFrame(pinNav);
};

export const getNavHeight = () => {
    return navHeight;
};



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/ModelNav/pinNav.js